import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrl: './signature-pad.component.scss'
})
export class SignaturePadComponent {

  signatureNeeded!: boolean;
  signaturePad!: SignaturePad;
  @ViewChild('canvas') canvasEl!: ElementRef;
  signatureImg!: string;

  @Output() signedImage = new EventEmitter<string>();  

  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit() {    
       
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
   
  }

  savePad() {
    this.signatureNeeded = this.signaturePad.isEmpty();

    if (!this.signatureNeeded) {
      this.signatureImg = this.signaturePad.isEmpty() ? null : this.signaturePad.toDataURL();
      this.signedImage.emit(this.signatureImg);
    }
  }

  clearPad() {
    this.signaturePad.clear();
    this.signedImage.emit(null);
  }

  startDrawing(event: Event) {
    this.signatureNeeded = false;
    // works in device not in browser
  }
  moved(event: Event) {
    // works in device not in browser
  }

  clearMessage(event: Event) {
    this.signatureNeeded = false;
  } 

}
